import { createBrowserRouter } from 'react-router';

import { AuthLogoutPage } from '../pages/AuthLogout/AuthLogoutPage';
import { DashboardPage } from '../pages/Dashboard/DashboardPage';
import { DatenschutzPage } from '../pages/Datenschutz/DatenschutzPage';
import { NotFoundPage } from '../pages/NotFound/NotFoundPage';
import { SearchPage } from '../pages/Search/SearchPage';
import { VATopicPage } from '../pages/SystemTopic/TopicPage';
import { VeranstaltungPage } from '../pages/Veranstaltung/VeranstaltungPage';
import { LayoutWithAuth } from './LayoutWithAuth/LayoutWithAuth';
import { RouterError } from './RouterError';
import { PATH } from './url';

export const appRouter = createBrowserRouter([
  {
    path: PATH.AUTH.ROOT,
    errorElement: <RouterError />,
    children: [
      {
        path: PATH.AUTH.LOGOUT,
        Component: AuthLogoutPage,
      },
    ],
  },
  {
    path: PATH.ROOT,
    element: <LayoutWithAuth />,
    errorElement: <RouterError />,
    children: [
      {
        Component: DashboardPage,
        index: true,
      },
      {
        Component: SearchPage,
        path: PATH.SUCHE,
      },
      {
        Component: VeranstaltungPage,
        path: PATH.VERANSTALTUNGEN,
      },
      {
        Component: DatenschutzPage,
        path: PATH.DATENSCHUTZ,
      },
      {
        Component: NotFoundPage,
        path: PATH.NOT_FOUND,
      },
    ],
  },
  {
    path: PATH.SYSTEM.ROOT,
    element: <LayoutWithAuth />,
    errorElement: <RouterError />,
    children: [
      {
        Component: VATopicPage,
        path: PATH.SYSTEM.TOPIC,
      },
    ],
  },
]);
